/**
 * Message lisible à partir d'une erreur axios / FastAPI.
 */
export function formatApiError(error, fallback = 'Une erreur est survenue.') {
  if (!error) return fallback;

  const status = error.response?.status;
  const data = error.response?.data;
  const detail = data?.detail ?? data?.message;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item.msg === 'string') return item.msg;
        return null;
      })
      .filter(Boolean);
    if (messages.length) return messages.join(', ');
  }

  if (detail && typeof detail === 'object') {
    try {
      return JSON.stringify(detail);
    } catch {
      // ignore
    }
  }

  if (typeof data === 'string' && data.trim()) {
    return data.slice(0, 200);
  }

  if (error.message === 'Network Error') {
    return 'Impossible de joindre l’API. Vérifiez que le backend (port 8401) est démarré et rechargez la page.';
  }

  if (status === 404) {
    return 'Fonctionnalité indisponible sur ce serveur (API non à jour). Redéployez le backend.';
  }

  if (status) {
    return `${fallback} (HTTP ${status})`;
  }

  return fallback;
}
